/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalTranscoderPartialUpdate
 */
export interface ExternalTranscoderPartialUpdate {
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof ExternalTranscoderPartialUpdate
     */
    pathMappings?: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {string}
     * @memberof ExternalTranscoderPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalTranscoderPartialUpdate
     */
    type?: ExternalTranscoderPartialUpdateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalTranscoderPartialUpdate
     */
    address?: string;
}

/**
* @export
* @enum {string}
*/
export enum ExternalTranscoderPartialUpdateTypeEnum {
    Transkoder = 'transkoder',
    Vantage = 'vantage'
}

export function ExternalTranscoderPartialUpdateFromJSON(json: any): ExternalTranscoderPartialUpdate {
    return ExternalTranscoderPartialUpdateFromJSONTyped(json, false);
}

export function ExternalTranscoderPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalTranscoderPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pathMappings': !exists(json, 'path_mappings') ? undefined : json['path_mappings'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'address': !exists(json, 'address') ? undefined : json['address'],
    };
}

export function ExternalTranscoderPartialUpdateToJSON(value?: ExternalTranscoderPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path_mappings': value.pathMappings,
        'name': value.name,
        'type': value.type,
        'address': value.address,
    };
}


